import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-bazaarvoice-rating',
    templateUrl: './bazaarvoice-rating.component.html',
    styleUrls: ['./bazaarvoice-rating.component.css'],
    standalone: false
})
export class BazaarvoiceRatingComponent implements OnInit {

  @Input() productId: any;

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      const container = document.getElementById("bazaarvoice-inline-rating-" + this.productId);
      if (!container) {
        return;
      }
      container.setAttribute("data-bv-product-id", this.productId);

      const cleanup = () => {
        container.querySelectorAll('.bv_sub_container .bv_text').forEach(el => {
          const text = el.textContent.trim();
          if (text === '0.0' || text === '(0)') {
            el.textContent = '';
          }
        });
        container.querySelectorAll('.bv_main_container').forEach(el => {
          el.removeAttribute('itemscope');
          el.removeAttribute('itemtype');
          el.removeAttribute('itemprop');
        });
      };

      // Bazaarvoice injects/re-renders the widget asynchronously with no
      // reliable completion callback, so observe the container instead of
      // guessing a fixed delay.
      const observer = new MutationObserver(cleanup);
      observer.observe(container, { childList: true, subtree: true, characterData: true });

      setTimeout(() => observer.disconnect(), 10000);
    });
  }

}